import { cn } from "@/lib/utils";
import { brl } from "@/lib/format";

export default function StatCard({ title, value, icon: Icon, sub, tone = "default", testid }) {
  const tones = {
    default: "text-foreground",
    success: "text-emerald-500",
    danger: "text-red-500",
  };
  return (
    <div
      data-testid={testid}
      className="rounded-xl border border-border bg-card p-5 transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-black/5"
    >
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
          {title}
        </span>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </div>
      <div className={cn("num mt-3 text-2xl sm:text-3xl font-semibold tracking-tight", tones[tone])}>
        {typeof value === "number" ? brl(value) : value}
      </div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
